import { estudioLabService, labAs400Service } from '@/views/laboratorio/services';


export const registerExamenes = async (tokenAtencion, dataStLaboratorios) => {

  let idEstudioLab          = dataStLaboratorios.estudioLab;
  const laboratoriosFinal   = dataStLaboratorios.final;
  const laboratoriosInicial = dataStLaboratorios.inicial;

  const labs400State       = laboratoriosFinal;

  if(!labs400State?.length)
    if(!laboratoriosInicial) return null;


  let responseLab = null;
      
  
  if(!idEstudioLab){
    // crear un estudio lab x primera vez para esta atencion
    const responseEstudioLab = await estudioLabService.create( tokenAtencion, '1' );
    idEstudioLab = responseEstudioLab.id;
  }

  // si existe el estLab solo se actulizan los examenes o se crean
  if(!idEstudioLab) {
    console.error('No se pudo crear el estudio de laboratorio');
    return null;
  }


  // as 400
  const labs400ToProcess = labs400State.map( 
    l => ({
      ...l, 
      examenes: l.examenes.map(e => e.id) 
    })
  );
  const labsAs400ToCreate = labs400ToProcess.filter( l => !l.id );
  const labsAs400ToUpdate = labs400ToProcess.filter( l => l.id );
  const labsAs400ToDelete = laboratoriosInicial?.filter(
    l => !labs400ToProcess.some( l400 => l400.id === l.id )
  )

  let labs400Created = null;
  let labs400Updated = null;
  let labs400Deleted = null;

  if (labsAs400ToCreate?.length)
    labs400Created = await Promise.all(
      labsAs400ToCreate.map(l400 => labAs400Service.create(idEstudioLab, l400))
    )
  if(labsAs400ToUpdate?.length)
    labs400Updated = await Promise.all(
      labsAs400ToUpdate.map(l400 => labAs400Service.updateByToken(l400.token, l400))
    )

  if(labsAs400ToDelete?.length)
    labs400Deleted = await Promise.all(
      labsAs400ToDelete.map(l400 => labAs400Service.deleteByToken(l400.token))
    );

  responseLab = {
    ...responseLab,
    lab400 : {
      created: labs400Created,
      updated: labs400Updated,
      deleted: labs400Deleted
    }
  }

  return responseLab;
}
